import { pick, values } from 'lodash/fp';

import { FIELD_NAMES } from '../../components/pricing-drawer/constants';
import { FieldNames } from '../../components/pricing-drawer/types';

type Params = {
  params: {
    [key in FieldNames]?: string;
  };
};

const getRefinePriceQueryValues = ({ params }: Params) => {
  const queryParams = values(FIELD_NAMES);
  return pick(queryParams, params);
};

export default getRefinePriceQueryValues;
